import React from "react";
import { IconBase, IconComponent } from "../../core/Icons";

/** Outline video camera — attendance evidence clips (distinct from DeviceIcon tablet). */
export const VideoIcon: React.FC<IconComponent> = (props) => {
  return (
    <IconBase {...props}>
      <rect x="4" y="11" width="21" height="16" rx="3" stroke="white" strokeWidth="2" fill="none" />
      <path d="M25 16.5 L33 12 V26 L25 21.5 Z" stroke="white" strokeWidth="2" strokeLinejoin="round" fill="none" />
      <circle cx="11" cy="19" r="3" fill="#8BC8FF" opacity="0.6" />
    </IconBase>
  );
};
